<script lang="ts">
	import { RentalSlugView } from "#lib/web-ui/rental/index.js";

	let { data } = $props();
</script>

<RentalSlugView unit={data.unit} />
